import { AnyAction, createSlice, Reducer, Slice } from '@reduxjs/toolkit';

import { PaginationDefaults } from '../../../../shared/utils/pagination-defaults.util';
import { getCampaignReportsTotalCount } from '../../thunks/get-campaign-reports-total-count.thunk';
import { getCampaignReports } from '../../thunks/get-campaign-reports.thunk';
import { CampaignReportsStateModel } from './models/campaign-reports-state.model';
import { CampaignReportsReducers } from './types/campaign-reports-reducers.type';

const initialState: CampaignReportsStateModel = {
  reports: [],
  pagination: {
    totalCount: PaginationDefaults.totalCount,
    pageNumber: PaginationDefaults.pageNumber,
    size: PaginationDefaults.size,
    offset: PaginationDefaults.offset,
  },
};

export const campaignReportsSlice: Slice<
  CampaignReportsStateModel,
  CampaignReportsReducers,
  string
> = createSlice({
  name: 'campaign-reports',
  initialState,
  reducers: {
    resetVehicleReports(state) {
      Object.assign(state, initialState);
    },
    setCampaignId(state, action) {
      state.campaignId = action.payload;
    },

    addPagination(state, action) {
      state.pagination.size = action.payload.size;
      state.pagination.offset = action.payload.offset;
      state.pagination.pageNumber = action.payload.pageNumber;
    },

    resetPagination(state, action) {
      state.pagination.offset = PaginationDefaults.offset;
      state.pagination.size = action.payload.size;
      state.pagination.pageNumber = PaginationDefaults.pageNumber;
    },
  },
  extraReducers: builder => {
    builder.addCase(getCampaignReports.fulfilled, (state, action) => {
      state.reports = action.payload;
    });
    builder.addCase(getCampaignReportsTotalCount.fulfilled, (state, action) => {
      state.pagination.totalCount = action.payload;
    });
  },
});

export const {
  resetVehicleReports,
  resetPagination,
  addPagination,
  setCampaignId,
} = campaignReportsSlice.actions;

const campaignReportsSliceReducers: Reducer<
  CampaignReportsStateModel,
  AnyAction
> = campaignReportsSlice.reducer;

export default campaignReportsSliceReducers;
